import styled from 'styled-components';

export const StyledList = styled.ul<{ columns?: number }>`
  columns: ${({ columns }) => columns};
  background: transparent;
  padding-left: 0;
`;

StyledList.defaultProps = {
  columns: 1,
};
